import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import WhyChooseSection from './components/WhyChooseSection';
import ProjectsSection from './components/ProjectsSection';
import FlowSection from './components/FlowSection';
import FAQSection from './components/FAQSection';
import AreaSection from './components/AreaSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <ServicesSection />
      <WhyChooseSection />
      <ProjectsSection />
      <FlowSection />
      <FAQSection />
      <AreaSection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
